import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { ModalpopService } from '../modalpop.service';
import { UmsService } from '../ums.service';
import { PrintMsgBoxComponent } from '../print-msg-box/print-msg-box.component';
import { AdmFeeStudentsComponent } from '../adm-fee-students/adm-fee-students.component';

@Component({
  selector: 'app-course-sc-edit',
  templateUrl: './course-sc-edit.component.html',
  styleUrls: ['./course-sc-edit.component.scss'],
})
export class CourseScEditComponent implements OnInit {

  submitButton = true;
  updateButton = false;
  showDiv = false;
  deleteReadOnly = false;
  Table = false;
  FeesNotPaid = false
  CourseSCEditForm: FormGroup;
  elgbRuleList;
  filteredElgbRuleList;
  filteredCourseAList;
  dialogRef: MatDialogRef<any>;
  // empty after assignig to api start
  CourseAList;
  courseRecords = [
  ];
  // empty after assignig to api end
  statusList = [
    {
      name: 'Open',
      id: 'O',
    },
    {
      name: 'Close',
      id: 'C',
    },
  ];
  filteredListOfEmEval: any;
  CourseInputList: any;
  filteredCourseInputList: any;
  filteredstatusList: any;
  userList: any;
  filtereduserList: any;
  Glob_EcShId: any;
  APIService: any;
  userPermission: any;
  utp: any;
  submitpayload
  CourseEditCreate = true;
  CourseEditUpdate = true;
  CourseEditDelete = true;
  loginId = sessionStorage.getItem('userId');
  SessionNo: any;
  CoCode: string;
  StuFee: any;
  EcIdForReport: any;
  ADMRecords: any;
  UpdateError: string;
  updateDisable = false;
  updateDisableFeePending =false;
  updateReadonly =false;
  sessionList: any[] = [];
  filteredSessionList: any[] = [];

  constructor(
    private modalPopupService: ModalpopService,
    public umsService: UmsService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    public router: Router,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private httpClient: HttpClient,
  ) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    this.updateDisable = false;
    this.updateDisableFeePending =false;
    this.updateReadonly =false;
    this.UpdateError = ''
    this.CoCode = '';
    this.FeesNotPaid = false
    this.fetchSessionList();
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if (this.utp !== 'Super Admin' && this.utp !== 'Admin') {
      // this.isSuperAdmin= false;
      this.userPermission.forEach(element => {
        if (element.PageName == 'Course-Edit-Control' && element.PCreate == false) {
          this.CourseEditCreate = false;
        }
        if (element.PageName == 'Course-Edit-Control' && element.PUpdate == false) {
          this.CourseEditUpdate = false;
        }
        if (element.PageName == 'Course-Edit-Control' && element.PDelete == false) {
          this.CourseEditDelete = false;
        }
      });
    }
    window.scroll(0, 0);
    this.fetchSupCourseInputs();
    this.getOpratorsList();
    this.Table = false;
    this.filteredstatusList = this.statusList.slice();
    // empty after assignig to api start
    this.CourseSCEditForm = this.fb.group({
      CEcShId: new FormControl('', Validators.required),
      CEcDesc: new FormControl('New'),
      CEcInCode: new FormControl('', Validators.required),
      CEcOpId: new FormControl('', Validators.required),
      CEcOpenOpId: new FormControl(sessionStorage.getItem('userId')),
      CEcStatus: new FormControl('O'),
      FrontCEcInCode: new FormControl(''),
      FrontList: new FormControl(''),
      CEcListNo: new FormControl(''),
      EcId: new FormControl(''),
      SessionId: new FormControl('', Validators.required),
    });
    // empty after assignig to api end
  }
  // fetchSecretData() {
  //   this.umsService.getSecretData().subscribe((res) => {
  //     this.SessionNo = res.projectPharam['SnNo']
  //     this.fetchSupCourseRecord(this.SessionNo);
  //   }
  //   );
  // }

  // submit() {
  //   if(this.CourseSCEditForm.value['FrontCEcInCode'] == 51){
  //     let payload = {};
  //     this.ADMRecords = [];
  //     payload['SnNo'] = parseInt(this.SessionNo);
  //     payload['InCode'] = 'ADM'
  //     payload['CoCode'] = this.CoCode
  //     this.umsService.CheckValidDate(payload).subscribe(res =>  {
  //       if (res.status) {
  //         const courseRecords = res.data.filter(record => record.CoCgCoCode === this.CoCode);
  //         const today = new Date();
  //         const todayDateString = today.toISOString().split('T')[0];
  //         if (courseRecords.length > 0) {
  //           this.ADMRecords = res.data.filter(record => record.InCode === 'ADM');
  //         }
  
  //         let listCanOpen = false;
  //         for (let item of this.ADMRecords) {
  //           if ((item.FromDate.split('T')[0] === todayDateString && todayDateString < item.ToDate.split('T')[0]) || (item.FromDate.split('T')[0] < todayDateString && todayDateString < item.ToDate.split('T')[0]) || (item.FromDate.split('T')[0] < todayDateString && todayDateString == item.ToDate.split('T')[0])) {
  //             listCanOpen = true;
  //             break;
  //           }
  //         }
          
  //         if (!listCanOpen) {
  //           if(this.ADMRecords.length == 0){
  //             this.showAlert('First Enter CutOff Dates For This Course');
  //           }
  //           else if(this.ADMRecords.length > 0){
  //             for (let item of this.ADMRecords) {
  //               if (todayDateString > item.ToDate.split('T')[0]) {
  //                 this.showAlert('Admission Dates Are Closed For This Course');
  //                 break;
  //               } else if (todayDateString < item.FromDate.split('T')[0]) {
  //                 this.showAlert('Admission Dates Are Still Not Open For This Course');
  //                 break;
  //               }
  //             }
  //           }
            
  //         }
  //         if(listCanOpen == true){
  //           this.submitFinal();
  //         }
  //       } else {
  //         this.showAlert('First Enter CutOff Dates For This Course');
  //       }
  //     });
  //   }
  //   else{
  //     this.submitFinal();
  //   }
    
    
   
  // }
  
 
  // showAlert(message: string) {
  //   let data = {
  //     message: message,
  //     title: 'Alert',
  //     icon: 'fas fa-close'
  //   };
  //   this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  // }
  

  // submitFinal() {
  //   if (this.CourseSCEditForm.valid) {
  //     this.spinner.show();
  //     if (this.CourseSCEditForm.value['CEcInCode'] == 52) {
  //       this.validateINcode52()
  //     } else {
  //       this.umsService.submitSupCourse(this.CourseSCEditForm.value).subscribe(
  //         (res) => {
  //           this.spinner.hide();
  //           if (res.status) {
  //             let data = {};
  //             data['message'] = res.message;
  //             data['title'] = 'Information';
  //             data['icon'] = 'fas fa-check';
  //             this.dialogRef =
  //               this.modalPopupService.openPopup<AlertBoxComponent>(
  //                 AlertBoxComponent,
  //                 data
  //               );
  //             this.fetchSupCourseEditRecord();
  //           }
  //         },
  //         (ERROR: HttpErrorResponse) => {
  //           this.spinner.hide();
  //           let data = {};
  //           data['message'] = ERROR.error.message;
  //           data['title'] = 'Information';
  //           data['icon'] = 'fas fa-close';
  //           this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
  //             AlertBoxComponent,
  //             data
  //           );
  //         }
  //       );
  //     }
  //   } else {
  //     this.CourseSCEditForm.get('CEcShId').markAsTouched();
  //     this.CourseSCEditForm.get('CEcInCode').markAsTouched();
  //     this.CourseSCEditForm.get('CEcOpId').markAsTouched();
  //   }
  // }

  // validateINcode52() {
  //   this.spinner.show();
  //   let count = 0
  //   this.courseRecords.forEach(element => {
  //     if (element.CEcStatus == 'O') {
  //       count = count + 1;
  //     }
  //   });
  //   if (count == 0) {
  //     this.umsService.submitSupCourse(this.CourseSCEditForm.value).subscribe(
  //       (res) => {
  //         this.spinner.hide();
  //         if (res.status) {
  //           let data = {};
  //           data['message'] = res.message;
  //           data['title'] = 'Information';
  //           data['icon'] = 'fas fa-check';
  //           this.dialogRef =
  //             this.modalPopupService.openPopup<AlertBoxComponent>(
  //               AlertBoxComponent,
  //               data
  //             );
  //           this.fetchSupCourseEditRecord();
  //         }
  //       },
  //       (ERROR: HttpErrorResponse) => {
  //         this.spinner.hide();
  //         let data = {};
  //         data['message'] = ERROR.error.message;
  //         data['title'] = 'Information';
  //         data['icon'] = 'fas fa-close';
  //         this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
  //           AlertBoxComponent,
  //           data
  //         );
  //       }
  //     );
  //   } else {
  //     this.spinner.hide();
  //     let gstrVldtMesg = 'Only One List Can Be Active';
  //     let data = {};
  //     data['message'] = gstrVldtMesg;
  //     data['title'] = 'Information';
  //     data['icon'] = 'fas fa-close';
  //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
  //       AlertBoxComponent,
  //       data
  //     );
  //   }
  // }
  fetchSessionList() {
    this.spinner.show();
    const payload = { SnActive: 'Y' };
    this.umsService.getSession(payload).subscribe({
      next: (res) => {
        this.spinner.hide();
        if (res.status) {
          this.sessionList = res.data || [];
          this.filteredSessionList = [...this.sessionList];
        } else {
          this.sessionList = [];
          this.filteredSessionList = [];
        }
      },
      error: (error: HttpErrorResponse) => {
        this.spinner.hide();
        this.sessionList = [];
        this.filteredSessionList = [];
      }
    });
  }
  onSessionChange(sessionId: any) {
    this.SessionNo = sessionId;
    this.CourseSCEditForm.controls['SessionId'].setValue(sessionId);
    this.resetFormOnSessionChange();
    if (sessionId) {
      this.fetchSupCourseRecord(sessionId);
    } else {
      this.CourseAList = [];
      this.filteredCourseAList = [];
    }
  }
  resetFormOnSessionChange() {
    this.CourseSCEditForm.patchValue({
      CEcShId: '',
      CEcInCode: '',
      FrontCEcInCode: '',
      CEcDesc: 'New',
      CEcOpId: '',
      CEcListNo: '',
      EcId: '',
    });
    this.showDiv = false;
    this.Table = false;
    this.courseRecords = [];
    this.CourseAList = [];
    this.filteredCourseAList = [];
  }

  fetchSecretData() {
    this.umsService.getSecretData().subscribe((res) => {
      this.SessionNo = res.projectPharam['SnNo']
      // No auto-load – user will select session
    }
    );
  }
  fetchSupCourseRecord(SessionNo?) {
    if (!SessionNo) {
      SessionNo = this.CourseSCEditForm.value['SessionId'];
    }
    if (!SessionNo) {
      this.CourseAList = [];
      this.filteredCourseAList = [];
      return;
    }
    this.spinner.show();
    let payload = {};
    payload['LoginId'] = sessionStorage.getItem('userId');
    payload['CShSnNo'] = SessionNo;
    this.umsService.getSupCourseRecord(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.CourseAList = res.data;
          this.filteredCourseAList = this.CourseAList.slice();
        } else {
          this.CourseAList = [];
          this.filteredCourseAList = this.CourseAList.slice();
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.CourseAList = [];
        this.filteredCourseAList = this.CourseAList.slice();
      }
    );
  }

  fetchSupCourseInputs() {
    this.spinner.show();
    let payload = {};
    this.umsService.getSupCourseInputs(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.CourseInputList = res.data;
          this.filteredCourseInputList = this.CourseInputList.slice();
        } else {
          this.CourseInputList = [];
          this.filteredCourseInputList = this.CourseInputList.slice();
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.CourseInputList = [];
        this.filteredCourseInputList = this.CourseInputList.slice();
      }
    );
  }

  fetchSupCourseEditRecord() {
    this.Table = false;
    this.showDiv = false;
    this.spinner.show();
    let payload = {};
    this.Glob_EcShId = this.CourseSCEditForm.value['EcShId'];
    payload['CEcShId'] = this.CourseSCEditForm.value['CEcShId'];
    payload['CEcInCode'] = this.CourseSCEditForm.value['FrontCEcInCode'];
    payload['CEcOpId'] = parseInt(sessionStorage.getItem('userId'));
    this.umsService.getSupCourseEditRecord(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.courseRecords = res.data;
          this.Table = true;
          this.updateDisable = false
        } else {
          this.courseRecords = [];
          this.Table = false;
          this.updateDisable = false
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.updateDisable = false
        this.spinner.hide();
        this.courseRecords = [];
      }
    );
  }

  getOpratorsList() {
    this.spinner.show();
    let payload = {};
    this.umsService.getUserList(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.status) {
          this.userList = res.data;
          this.filtereduserList = this.userList.slice();
        } else {
          this.userList = [];
          this.filtereduserList = this.userList.slice();
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.userList = [];
        this.filtereduserList = this.userList.slice();
      }
    );
  }

  prepopulate(e) {
    this.submitButton = false;
    this.updateReadonly =true;
    this.showDiv = true;
    if (e.CEcStatus == 'O') {
      this.updateButton = true;
    } else {
      this.updateButton = false;
    }
    this.CourseSCEditForm.controls['CEcDesc'].setValue(e.CEcDesc);
    this.CourseSCEditForm.controls['CEcOpId'].setValue(e.LoginIdL1);
    this.CourseSCEditForm.controls['CEcListNo'].setValue(e.CEcListNo);
    this.CourseSCEditForm.controls['CEcInCode'].setValue(e.CEcInCode);
    this.CourseSCEditForm.controls['EcId'].setValue(e.CEcId);
    this.EcIdForReport = e.CEcId
  }



  updateInput(e) {
    this.spinner.show();
    let payload = {};
    payload['LoginId'] = sessionStorage.getItem('userId'),
      payload['EcId'] = e.EcId,
      payload['InCode'] = e.InCode,
      payload['Inst'] = parseInt(sessionStorage.getItem('Inst'));
    this.umsService.UpdateSCHInput(payload).subscribe(
      (res) => {
        this.spinner.hide();
        let gstrVldtMesg = res.message;
        let data = {};
        data['message'] = gstrVldtMesg;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-check';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
        this.fetchSupCourseEditRecord();
        return false;
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        // alert(ERROR);
      }
    );
  }


  deleteInput(e) {
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        "CEcId": e.EcId,
        "CEcShId": e.CEcShId,
        "CEcInCode": e.CEcInCode,
        "CEcStatus": e.CEcStatus,
        "CEcOpId": e.CEcOpId,
        "CEcOpenOpId": parseInt(e.CEcOpenOpId),
        "CEcDesc": e.CEcDesc,
        "CEcExtr1": "",
        "CEcExtr2": ""
      },
    };
    this.httpClient.delete(this.APIService + '/supervisor/courseEditControl', options)
      .subscribe((s) => {
        this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.fetchSupCourseEditRecord();
        });
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.fetchSupCourseEditRecord();
      });

  }

  delete() {
    let payload = {};
    payload = this.CourseSCEditForm.value;
    payload['EcId'] = this.CourseSCEditForm.value['EcId'];
    payload['InCode'] = this.CourseSCEditForm.value['CEcInCode'];
    let data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef =
      this.modalPopupService.openPopup<ConformationModelComponent>(
        ConformationModelComponent,
        data
      );
    this.dialogRef.afterClosed().subscribe((result) => {
      if (result === 'yes') {
        this.deleteInput(payload);
        return true;
      } else {
        let gstrVldtMesg = 'Processing Cancelled';
        let data = {};
        data['message'] = gstrVldtMesg;
        data['title'] = 'Information';
        data['icon'] = 'fas fa-close';
        this.dialogRef =
          this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        return false;
      }
    });
  }

  addNew() {
    let tempEcShId = this.CourseSCEditForm.value['CEcShId'];
    let temp = this.CourseSCEditForm.value['FrontCEcInCode'];
    let session = this.CourseSCEditForm.value['SessionId']; // preserve session
    if (this.CourseSCEditForm.controls['CEcShId'].valid) {
      this.submitButton = true;
      this.showDiv = true;
      this.updateButton = false;
      this.updateReadonly =false;
      this.CourseSCEditForm.reset();
      this.CourseSCEditForm.controls['CEcShId'].setValue(tempEcShId);
      this.CourseSCEditForm.controls['FrontCEcInCode'].setValue(temp);
      this.CourseSCEditForm.controls['SessionId'].setValue(session); // restore session
      this.CourseSCEditForm.controls['CEcDesc'].setValue('New');
      this.CourseSCEditForm.controls['CEcOpId'].setValue(parseInt(this.loginId));
      this.CourseSCEditForm.controls['CEcOpenOpId'].setValue(parseInt(this.loginId));
      this.CourseSCEditForm.controls['CEcStatus'].setValue('O');
    } else {
      this.CourseSCEditForm.get('CEcShId').markAsTouched();
    }
  }

  reset(course, code) {
    const sessionId = this.CourseSCEditForm.value['SessionId'];
    const frontInCode = this.CourseSCEditForm.value['FrontCEcInCode'];

    this.CoCode = code;
    this.showDiv = false;
    this.Table = false;
    this.updateDisable = false;
    this.FeesNotPaid = false;
    this.updateDisableFeePending = false;
    this.CourseSCEditForm.reset();
    this.CourseSCEditForm.controls['CEcShId'].setValue(course);
    if (sessionId) {
      this.CourseSCEditForm.controls['SessionId'].setValue(sessionId);
    }
    if (frontInCode) {
      this.CourseSCEditForm.controls['FrontCEcInCode'].setValue(frontInCode);
    }
    this.CourseSCEditForm.controls['CEcDesc'].setValue('New');
    this.CourseSCEditForm.controls['CEcOpId'].setValue(parseInt(this.loginId));
    this.CourseSCEditForm.controls['CEcOpenOpId'].setValue(parseInt(this.loginId));
    this.CourseSCEditForm.controls['CEcStatus'].setValue('O');
  }

  printAll() {
    if (this.CourseSCEditForm.controls['CEcShId'].valid) {
      let data = {};
      data['message'] = 'Select from dropdown';
      data['title'] = 'Information';
      data['icon'] = 'fas fa-box-open';
      this.dialogRef = this.dialog.open(PrintMsgBoxComponent, {
        disableClose: true,
        data,
      });
      this.dialogRef.afterClosed().subscribe(result => {
        this.PrintAll(result)
      });
    } else {
      this.CourseSCEditForm.get('CEcShId').markAsTouched();
    }
  }

  PrintAll(data) {
    this.submitpayload = this.CourseSCEditForm.value;
    let payload1 = {}
    payload1['EcId'] = this.CourseSCEditForm.value['CEcShId'],
      payload1['ShId'] = this.CourseSCEditForm.value['CEcShId'],
      payload1['MenuName'] = 'Course Edit ControlAll';
    payload1['Title'] = '';
    payload1['SubTitle'] = 0;
    payload1['InCode'] = 0;
    payload1['AllLast'] = data
    let jsonString = JSON.stringify(payload1);
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 105,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": '',//this.emid
      "CsNo": '',
      "PgBreak": '',
      "StrId": '', //this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": this.CourseSCEditForm.value['CEcInCode'] ? this.CourseSCEditForm.value['CEcInCode'] : 0,
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

  print() {
    this.submitpayload = this.CourseSCEditForm.value;
    let payload1 = {}
    payload1['EcId'] = this.EcIdForReport,
      payload1['MenuName'] = 'Course Edit Control';
    payload1['InCode'] = this.CourseSCEditForm.value['CEcInCode'];
    payload1['Title'] = '';
    payload1['SubTitle'] = this.CourseSCEditForm.value['CEcInCode'];
    let jsonString = JSON.stringify(payload1);
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 132,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": '',//this.emid
      "CsNo": '',
      "PgBreak": '',
      "StrId": '', //this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": this.CourseSCEditForm.value['CEcInCode'] ? this.CourseSCEditForm.value['CEcInCode'] : 0,
      "SnNo": this.SessionNo,
      "Extra1": jsonString,
    }

    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }

  redirect(to): void {
    this.router.navigate([to]);
  }

  update(){
    this.updateDisable = true;
  let payload = {};
    this.ADMRecords = [];
    payload['SnNo'] = parseInt(this.SessionNo);
    payload['InCode'] = 'ADM'
    payload['CoCode'] = this.CoCode
    this.umsService.CheckValidDate(payload).subscribe(res =>  {
      if (res.status) {
        const courseRecords = res.data.filter(record => record.CoCgCoCode === this.CoCode);
        const today = new Date();
        const todayDateString = today.toISOString().split('T')[0];
        if (courseRecords.length > 0) {
          this.ADMRecords = res.data.filter(record => record.InCode === 'ADM');
        }

        let listCanOpen = false;
        for (let item of this.ADMRecords) {
          if ((item.FromDate.split('T')[0] < todayDateString && todayDateString > item.ToDate.split('T')[0])) {
            listCanOpen = true;
            break;
          }
        }
        
        if (!listCanOpen) {
          if(this.ADMRecords.length == 0){
            this.showAlert('First Enter CutOff Dates For This Course');
          }
          else if(this.ADMRecords.length > 0){
            for (let item of this.ADMRecords) {
              if ((todayDateString < item.ToDate.split('T')[0]) || (todayDateString == item.FromDate.split('T')[0])) {
                this.showAlert('Admission Dates Are Still Open For This Course');
                break;
              } 
            }
          }
          
        }
        if(listCanOpen == true){
          this.updateCheck()
        }
      } else {
        this.showAlert('First Enter CutOff Dates For This Course');
      }
    });
  }
  
  // real working (temp comment )
  // updateCheck() {
  //   this.updateDisable = true;
  //   this.StuFee = []
  //   let payload2 = {};
  //   payload2['CoCode'] = this.CoCode
  //   payload2['SnNo'] = this.SessionNo
  //   this.umsService.AdmFeeDetails(payload2).subscribe((res) => {
  //     if (res.status) {
  //       let anyConditionMet = false;
  //       const filteredElements = res.data.filter(element => {
  //         if (element.FeeAmt == null && element.TotalPaidAmount == null) {
  //           anyConditionMet = true;
  //           this.StuFee.push(element);
  //           return true;
  //         } else if (element.FeeAmt != element.TotalPaidAmount) {
  //           anyConditionMet = true;
  //           this.StuFee.push(element);
  //           return true;
  //         } else if (element.FeeAmt == element.TotalPaidAmount && element.FeeAmt != null && element.TotalPaidAmount != null) {
  //           return false;
  //         }
  //       });

  //       this.FeesNotPaid = anyConditionMet;

  //       if (anyConditionMet) {
  //         const data = {
  //           message: `Admission Fees Payment Pending`,
  //           title: 'Alert',
  //           icon: 'fa fa-question'
  //         };
  //         this.updateDisableFeePending =true;
  //         this.UpdateError = data.message
  //         this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //       }
  //       else {
  //         this.updateFinal();
  //       }
  //     } else {
  //       this.updateFinal();
  //     }
  //   })

  // }

   //when error (temp solution)
  updateCheck() {
    this.updateDisable = true;
    this.StuFee = []
    let payload2 = {};
    payload2['CoCode'] = this.CoCode
    payload2['SnNo'] = this.SessionNo
    this.umsService.AdmFeeDetails(payload2).subscribe((res) => {
      if (res.status) {
        let anyConditionMet = false;
        const filteredElements = res.data.filter(element => {
          if (element.FeeAmt == null && element.TotalPaidAmount == null) {
            anyConditionMet = true;
            this.StuFee.push(element);
            return true;
          } else if (element.FeeAmt != element.TotalPaidAmount) {
            anyConditionMet = true;
            this.StuFee.push(element);
            return true;
          } else if (element.FeeAmt == element.TotalPaidAmount && element.FeeAmt != null && element.TotalPaidAmount != null) {
            return false;
          }
        });

        this.FeesNotPaid = anyConditionMet;

        if (anyConditionMet) {
          const data = {
            message: `Admission Fees Payment Pending`,
            title: 'Alert',
            icon: 'fa fa-question'
          };
          this.updateDisableFeePending =true;
          this.UpdateError = data.message
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
        else {
          this.updateFinal();
        }
      } else {
        this.updateFinal();
      }
    })

  }

  updateFinal() {
    this.spinner.show();
    let payload = {};
    payload['EcId'] = this.CourseSCEditForm.value['EcId'];
    payload['InCode'] = this.CourseSCEditForm.value['CEcInCode'];
    this.umsService.ValidateSCHInput(payload).subscribe(
      (res) => {
        this.spinner.hide();
        if (res.message == '') {
          let data = {};
          data['message'] =
            'Database will be updated. Database Tags will be removed and the list will be marked Updated' +
            ', Proceed?';
          data['title'] = 'Process Result';
          data['icon'] = 'fa fa-question';
          this.dialogRef =
            this.modalPopupService.openPopup<ConformationModelComponent>(
              ConformationModelComponent,
              data
            );
          this.dialogRef.afterClosed().subscribe((result) => {
            if (result === 'yes') {
              this.updateDisable = true;
              this.updateInput(payload);
              return true;
            } else {
              this.updateDisable = false;
              let gstrVldtMesg = 'Processing Cancelled';
              let data = {};
              data['message'] = gstrVldtMesg;
              data['title'] = 'Information';
              data['icon'] = 'fas fa-close';
              this.dialogRef =
                this.modalPopupService.openPopup<AlertBoxComponent>(
                  AlertBoxComponent,
                  data
                );
              return false;
            }
          });
        } else {
          this.updateDisable = false;
          let gstrVldtMesg = res.message;
          let data = {};
          data['message'] = gstrVldtMesg;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
          return false;
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.updateDisable = false;
        this.spinner.hide();
        // alert(ERROR);
      }
    );
  }

  openGrid() {
    let data = {}
    data['data'] = this.StuFee;
    const dialogRef = this.dialog.open(AdmFeeStudentsComponent, {
      width: '130vh',
      data,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  submit() {
    if(this.CourseSCEditForm.value['FrontCEcInCode'] == 51){
      let payload = {};
      this.ADMRecords = [];
      payload['SnNo'] = parseInt(this.SessionNo);
      payload['InCode'] = 'ADM'
      payload['CoCode'] = this.CoCode
      this.umsService.CheckValidDate(payload).subscribe(res =>  {
        if (res.status) {
          const courseRecords = res.data.filter(record => record.CoCgCoCode === this.CoCode);
          const today = new Date();
          const todayDateString = today.toISOString().split('T')[0];
          if (courseRecords.length > 0) {
            this.ADMRecords = res.data.filter(record => record.InCode === 'ADM');
          }
  
          let listCanOpen = false;
          for (let item of this.ADMRecords) {
            if ((item.FromDate.split('T')[0] === todayDateString && todayDateString < item.ToDate.split('T')[0]) || (item.FromDate.split('T')[0] < todayDateString && todayDateString < item.ToDate.split('T')[0]) || (item.FromDate.split('T')[0] < todayDateString && todayDateString == item.ToDate.split('T')[0])) {
              listCanOpen = true;
              break;
            }
          }
          
          if (!listCanOpen) {
            if(this.ADMRecords.length == 0){
              this.showAlert('First Enter CutOff Dates For This Course');
            }
            else if(this.ADMRecords.length > 0){
              for (let item of this.ADMRecords) {
                if (todayDateString > item.ToDate.split('T')[0]) {
                  this.showAlert('Admission Dates Are Closed For This Course');
                  break;
                } else if (todayDateString < item.FromDate.split('T')[0]) {
                  this.showAlert('Admission Dates Are Still Not Open For This Course');
                  break;
                }
              }
            }
            
          }
          if(listCanOpen == true){
            this.submitFinal();
          }
        } else {
          this.showAlert('First Enter CutOff Dates For This Course');
        }
      });
    }
    else{
      this.submitFinal();
    } 
  }

  showAlert(message: string) {
    let data = {
      message: message,
      title: 'Alert',
      icon: 'fas fa-close'
    };
    this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  }

  submitFinal() {
    if (this.CourseSCEditForm.valid) {
      this.spinner.show();
      if (this.CourseSCEditForm.value['CEcInCode'] == 52) {
        this.validateINcode52()
      } else {
        this.umsService.submitSupCourse(this.CourseSCEditForm.value).subscribe(
          (res) => {
            this.spinner.hide();
            if (res.status) {
              let data = {};
              data['message'] = res.message;
              data['title'] = 'Information';
              data['icon'] = 'fas fa-check';
              this.dialogRef =
                this.modalPopupService.openPopup<AlertBoxComponent>(
                  AlertBoxComponent,
                  data
                );
              this.fetchSupCourseEditRecord();
            }
          },
          (ERROR: HttpErrorResponse) => {
            this.spinner.hide();
            let data = {};
            data['message'] = ERROR.error.message;
            data['title'] = 'Information';
            data['icon'] = 'fas fa-close';
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
              AlertBoxComponent,
              data
            );
          }
        );
      }
    } else {
      this.CourseSCEditForm.get('CEcShId').markAsTouched();
      this.CourseSCEditForm.get('CEcInCode').markAsTouched();
      this.CourseSCEditForm.get('CEcOpId').markAsTouched();
    }
  }

  validateINcode52() {
    this.spinner.show();
    let count = 0
    this.courseRecords.forEach(element => {
      if (element.CEcStatus == 'O') {
        count = count + 1;
      }
    });
    if (count == 0) {
      this.umsService.submitSupCourse(this.CourseSCEditForm.value).subscribe(
        (res) => {
          this.spinner.hide();
          if (res.status) {
            let data = {};
            data['message'] = res.message;
            data['title'] = 'Information';
            data['icon'] = 'fas fa-check';
            this.dialogRef =
              this.modalPopupService.openPopup<AlertBoxComponent>(
                AlertBoxComponent,
                data
              );
            this.fetchSupCourseEditRecord();
          }
        },
        (ERROR: HttpErrorResponse) => {
          this.spinner.hide();
          let data = {};
          data['message'] = ERROR.error.message;
          data['title'] = 'Information';
          data['icon'] = 'fas fa-close';
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
            AlertBoxComponent,
            data
          );
        }
      );
    } else {
      this.spinner.hide();
      let gstrVldtMesg = 'Only One List Can Be Active';
      let data = {};
      data['message'] = gstrVldtMesg;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-close';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
        AlertBoxComponent,
        data
      );
    }
  }
}